<template>
  <div class="glPage">
    <!-- 顶部品牌化头部 -->
    <div class="glHeader">
      <i class="glBack" @click="goBack"></i>
      <span class="glTitle">{{ cateName }}</span>
    </div>

    <!-- 搜索 -->
    <div class="glSearch">
      <van-search v-model="searchKey" shape="round" background="transparent" placeholder="搜索游戏名称" />
    </div>

    <!-- 顶部 TAB -->
    <div class="glTabs">
      <div :class="activeTab == 'all' ? 'glTab on' : 'glTab'" @click="changeTab('all')">全部</div>
      <div :class="activeTab == 'hot' ? 'glTab on' : 'glTab'" @click="changeTab('hot')">热门</div>
      <div :class="activeTab == 'recent' ? 'glTab on' : 'glTab'" @click="changeTab('recent')">最近</div>
    </div>

    <!-- 主体：左厂商侧栏 + 右游戏 -->
    <div class="glBody">
      <!-- 左侧同类厂商切换 -->
      <div class="glRail">
        <div v-for="(v, vi) in vendors" :key="vi" :class="v.platform_name == platform ? 'rItem on' : 'rItem'" @click="switchVendor(v)">
          <div class="rIcon"><img :src="xhLogo(v.platform_name)" @error="onIconErr($event, v)" alt="" /></div>
          <p>{{ v.name }}</p>
        </div>
      </div>

      <!-- 右侧游戏网格 -->
      <div class="glMain">
        <div class="gameList" v-if="displayList.length > 0">
          <div class="gameLis" v-for="(item, index) in displayList" :key="index" @click="openGame(item)">
            <img :src="item.gamepic" alt="" />
            <p>{{ item.gamename }}</p>
          </div>
        </div>
        <div v-else class="glEmpty">{{ emptyText }}</div>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  name: 'gamelist',
  data() {
    return {
      platform: '',
      cate: '',
      title: '',
      searchKey: '',
      activeTab: 'all',
      allList: [],
      hotList: [],
      recentList: [],
      recentLoaded: false,
      loaded: false,
      cateLabels: {
        concise: '电子',
        joker: '棋牌',
        fishing: '捕鱼',
        realbet: '真人',
        sport: '体育',
        gaming: '电竞',
        lottery: '彩票',
      },
    };
  },
  created() {
    this.ensureVendors();
    this.initFromQuery();
  },
  computed: {
    cateName() {
      return this.cateLabels[this.cate] || this.title || '游戏列表';
    },
    // 当前分类下的同类厂商（用于左侧切换栏）
    vendors() {
      return this.$store.state[this.cate + 'List'] || [];
    },
    // 当前 TAB 的基础列表
    baseList() {
      if (this.activeTab == 'hot') return this.hotList;
      if (this.activeTab == 'recent') return this.recentList;
      return this.allList;
    },
    // 叠加搜索过滤
    displayList() {
      let key = (this.searchKey || '').trim().toLowerCase();
      if (!key) return this.baseList;
      return this.baseList.filter(g => (g.gamename || '').toLowerCase().indexOf(key) > -1);
    },
    emptyText() {
      if (!this.loaded && this.activeTab != 'recent') return '加载中...';
      if (this.activeTab == 'recent') {
        if (!this.$store.state.token) return '登录后查看最近玩过的游戏';
        return this.recentLoaded ? '暂无最近游戏记录' : '加载中...';
      }
      if (this.searchKey) return '没有搜到相关游戏';
      return '暂无游戏';
    },
  },
  methods: {
    goBack() {
      // 直接回首页，避免历史栈里夹着落地页跳转导致返回失败
      this.$router.replace('/');
    },
    // 侧栏为空时（直达/刷新）尝试补数据
    ensureVendors() {
      if (this.vendors && this.vendors.length > 0) return;
      this.$store.commit('changGameList'); // 先从 localStorage 灌
      if ((this.$store.state[this.cate + 'List'] || []).length == 0 && this.$parent.getGameList) {
        this.$parent.getGameList(); // 仍空则拉接口，store 更新后侧栏自动刷新
      }
    },
    initFromQuery() {
      let q = this.$route.query;
      this.platform = q.platform || '';
      this.cate = q.cate || '';
      this.title = q.title ? decodeURIComponent(q.title) : '';
      this.searchKey = '';
      this.activeTab = 'all';
      this.recentLoaded = false;
      this.recentList = [];
      this.getSubgames();
    },
    getSubgames() {
      let that = this;
      if (!that.platform || !that.cate) return;
      that.allList = [];
      that.hotList = [];
      that.loaded = false;
      that.$parent.showLoading();
      that.$apiFun
        .post('/api/subgamesByPlatform', { platform_name: that.platform, category_id: that.cate })
        .then(res => {
          if (res.code != 200) {
            that.$parent.showTost(0, res.message);
          }
          if (res.code == 200) {
            that.allList = res.data || [];
            that.hotList = that.pickHot(that.allList);
          }
          that.loaded = true;
          that.$parent.hideLoading();
        })
        .catch(() => {
          that.loaded = true;
          that.$parent.hideLoading();
        });
    },
    getRecent() {
      let that = this;
      if (!that.platform || !that.cate) return;
      if (!that.$store.state.token) {
        that.recentLoaded = true;
        return;
      }
      that.$apiFun
        .post('/api/recentGamesByPlatform', { platform_name: that.platform, category_id: that.cate })
        .then(res => {
          if (res.code == 200) {
            that.recentList = res.data || [];
          }
          that.recentLoaded = true;
        })
        .catch(() => {
          that.recentLoaded = true;
        });
    },
    // 从全量里随机抽 ~12 款作为热门
    pickHot(list) {
      let arr = (list || []).slice();
      for (let i = arr.length - 1; i > 0; i--) {
        let j = Math.floor(Math.random() * (i + 1));
        let t = arr[i];
        arr[i] = arr[j];
        arr[j] = t;
      }
      return arr.slice(0, 12);
    },
    changeTab(tab) {
      this.activeTab = tab;
      if (tab == 'recent' && !this.recentLoaded) {
        this.getRecent();
      }
    },
    // 原地切换同类厂商
    switchVendor(v) {
      if (!v || v.platform_name == this.platform) return;
      this.$router.replace({
        path: '/gamelist',
        query: { platform: v.platform_name, cate: v.category_id || this.cate, title: v.name || '' },
      });
      // 路由 query 变化触发 watch->initFromQuery 重新加载
    },
    openGame(item) {
      this.$parent.openGamePage(item.catecode, item.gamecode, item.gametype);
    },
    xhLogo(code) {
      return 'https://alicdn.xh-img.com/uploads/images/gamelogo/' + code + 'LOGO.webp';
    },
    localVendorImg(v) {
      return v.mobile_img || v.api_logo_img || v.app_img || v.game_icon || '';
    },
    onIconErr(e, v) {
      // XH logo 加载失败 → 回退本地 logo（一次，避免死循环）
      let el = e.target;
      if (el.dataset.fb) return;
      el.dataset.fb = '1';
      el.src = this.localVendorImg(v);
    },
  },
  watch: {
    $route: {
      handler() {
        this.initFromQuery();
      },
    },
  },
};
</script>
<style lang="scss" scoped>
.glPage {
  width: 100%;
  min-height: 100vh;
  background: #f7f8fa;
}
.glHeader {
  height: 46px;
  display: flex;
  align-items: center;
  justify-content: center;
  position: relative;
  background: linear-gradient(135deg, #2f6bff, #1e50e0);
  color: #fff;
  .glBack {
    position: absolute;
    left: 14px;
    top: 50%;
    width: 12px;
    height: 12px;
    border-left: 2px solid #fff;
    border-bottom: 2px solid #fff;
    transform: translateY(-50%) rotate(45deg);
  }
  .glTitle {
    font-size: 17px;
    font-weight: 600;
  }
}
.glSearch {
  padding: 6px 6px 0;
  background: #f7f8fa;
  ::v-deep .van-search__content {
    background: #fff;
    border: 1px solid #eef0f3;
  }
}
.glTabs {
  display: flex;
  padding: 4px 10px 8px;
  background: #f7f8fa;
  .glTab {
    padding: 6px 18px;
    margin-right: 10px;
    font-size: 13px;
    color: #64748b;
    background: #fff;
    border: 1px solid #eef0f3;
    border-radius: 16px;
  }
  .glTab.on {
    color: #fff;
    background: linear-gradient(135deg, #2f6bff, #1e50e0);
    border-color: transparent;
    font-weight: 600;
  }
}
// 单滚动条：去掉两栏各自 overflow，整页滚动；左厂商栏 sticky 保持可见
.glBody {
  display: flex;
  align-items: flex-start;
  box-sizing: border-box;
}
.glRail {
  width: 76px;
  flex: 0 0 76px;
  position: sticky;
  position: -webkit-sticky;
  top: 0;
  align-self: flex-start;
  padding: 4px 6px 12px;
  box-sizing: border-box;
  .rItem {
    text-align: center;
    padding: 8px 2px;
    margin-bottom: 6px;
    background: #fff;
    border-radius: 10px;
    .rIcon {
      width: 40px;
      height: 40px;
      margin: 0 auto;
      display: flex;
      align-items: center;
      justify-content: center;
      img {
        max-width: 100%;
        max-height: 100%;
        display: block;
      }
    }
    p {
      font-size: 10px;
      color: #7a6a63;
      margin: 4px 0 0;
      white-space: nowrap;
      overflow: hidden;
      text-overflow: ellipsis;
    }
  }
  .rItem.on {
    background: linear-gradient(135deg, #2f6bff, #1e50e0);
    box-shadow: 0 4px 10px rgba(47, 107, 255, 0.3);
    p {
      color: #fff;
    }
  }
}
.glMain {
  flex: 1;
  padding-bottom: 20px;
  box-sizing: border-box;
  .gameList {
    display: flex;
    flex-wrap: wrap;
    width: 96%;
    margin: 4px auto;
    .gameLis {
      position: relative;
      width: calc(33.33% - 8px);
      margin-right: 8px;
      margin-top: 8px;
      cursor: pointer;
      img {
        display: block;
        width: 100%;
        /* XH 子游戏图源比例不统一(1:1 方图 / 5:3 或 3:2 横图混排)，
           统一成固定 4:3 box + cover 裁切，保证整格视觉一致 */
        aspect-ratio: 4 / 3;
        object-fit: cover;
        background: #f1f5f9;
        border-radius: 10px;
      }
      p {
        text-align: center;
        font-size: 11px;
        color: #475569;
        margin: 3px 0 0;
        white-space: nowrap;
        overflow: hidden;
        text-overflow: ellipsis;
      }
    }
  }
  .glEmpty {
    text-align: center;
    color: #999;
    padding: 50px 0;
    font-size: 13px;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/mode/gamelist.vue